import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';

const NAME = 'SearchField';

class SearchField extends BaseComponent {
	constructor(element) {
		super(element);
		this.selectFieldClass='js-search-field-select';
		this.inputFieldClass='js-search-field-input';
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {

		const selectElement = SelectorEngine.findOne(`.${this.selectFieldClass}`, this._element);
		const inputElement = SelectorEngine.findOne(`.${this.inputFieldClass}`, this._element);

		if(selectElement) {
			const options = SelectorEngine.find(`option`, selectElement);
			if(options) {
				const optionsElements = [...options];
				EventHandler.on(selectElement, 'change', (event) => {
					const selectedOptionElement = optionsElements.find((option) => option.value === event.target.value);
					const { placeholder } = Manipulator.getDataAttributes(selectedOptionElement);
					inputElement.placeholder = placeholder;
				});
			}
		}

	}
}

export default SearchField;
